import type { Booking } from '@brighterly/lib-core-types/booking/interfaces'

import { useCustomerStore } from '@entities/customer/@x/booking'
import { useCsRoutes } from '@shared/api'

import { useBookingStore } from '../model/store/store'

interface CurrentBookingApiPayload {
  disciplineId: number
  background: boolean
}

interface CurrentBookingApiOptions {
  onStart?: () => void
  onError?: (err: any) => void
  onSuccess?: (booking: Booking | null) => void
  onFinish?: () => void
}

export const useCurrentBookingApi = async (payload: CurrentBookingApiPayload, options?: CurrentBookingApiOptions): Promise<null | Booking> => {
  const { $axios } = useNuxtApp()

  const customerStore = useCustomerStore()
  const bookingStore = useBookingStore()

  const { disciplineId } = payload

  const url = useCsRoutes('bookings.current', {
    '[discipline_id]': disciplineId,
    with_canceled: customerStore.isDisciplinePaidById(disciplineId) ? 1 : 0,
  })

  options?.onStart?.()

  const isRefresh = payload.background && bookingStore.getCurrentStatus(disciplineId) === 'ready'
  const requestId = bookingStore.beginCurrent(disciplineId, isRefresh ? 'refresh' : 'enter')
  if (!isRefresh) bookingStore.setCountdown(null)

  try {
    const { data } = await $axios.get(url!)
    const booking = (data?.data || null) as Booking | null

    bookingStore.settleCurrent(disciplineId, requestId, booking)
    bookingStore.setBookingTrigger()
    options?.onSuccess?.(booking)

    return booking
  } catch (err) {
    bookingStore.failCurrent(disciplineId, requestId)
    options?.onError?.(err)

    return null
  } finally {
    options?.onFinish?.()
  }
}
